// StatsSection.jsx
import { useContext, useEffect, useState } from "react";
import { StatBox } from "./componentAnimation";
import { useHttp } from "../../../utils/DataHendler";
import { LanguageContext } from "../../../context/Language.contex";

export const StatsSection = ({ inView }) => {
  const { getData } = useHttp();
  const [statisticData, setStatisticData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { language } = useContext(LanguageContext);

  // const getStatistic = async () => {
  //   setLoading(true);
  //   try {
  //     const response = await getData(`/guest/statistik`, {}, false);

  //     const data = response.data;

  //     // Convert object to array format
  //     // const formattedStats = [
  //     //   { title: "Umkm", target: data.total_umkm },
  //     //   { title: "Kategori", target: data.total_category },
  //     //   { title: "Produk", target: data.total_product },
  //     // ];

  //     // setStatisticData(formattedStats);
  //   } catch (error) {
  //     console.error("Failed to fetch statistics:", error);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // useEffect(() => {
  //   getStatistic();
  // }, []);

  const data = [
    {
      title: language[9],
      target: 426,
    },
    {
      title: language[10],
      target: 13,
    },
    {
      title: language[11],
      target: 50,
    },
  ];
  return (
    <div
      style={{
        display: "flex",
        gap: 24,
        justifyContent: "center",
        alignItems: "center",
        padding: 40,
        background: "#f9fafe",
        flexWrap: "wrap",
        position: "relative",
      }}
    >
      {/* Blur Ornamen di bawah kiri */}
      <div
        style={{
          position: "absolute",
          bottom: 280,
          left: -90,
          width: 300,
          height: 300,
          background: "rgba(0, 166, 225, 0.29)",
          filter: "blur(120px)",
          zIndex: 0,
        }}
      />
      {data.map((item, index) => (
        <StatBox
          key={index}
          title={item.title}
          target={item.target}
          shouldAnimate={inView}
        />
      ))}
    </div>
  );
};
